// extracted by mini-css-extract-plugin
export var childrenContainer = "_4z-0";
export var virtualScrollArea = "_4z-1";